<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      :text="resourceTitle"
      class="mb-0"
      v-if="resourceTitle"
    >
    </ItpText>
    <ItpText
      tag="h5"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <b-button-group
    class="ml-auto"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto"
      v-if="!item.isNew"
      @click.prevent.stop="evh_1040167445267876_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!item.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Lock'|pgettext('BtnLockText')"
        :tooltip="'Lock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_lock"
        @click.prevent.stop="evh_3601807637515735_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Unlock'|pgettext('BtnLockText')"
        :tooltip="'Unlock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_unlock"
        @click.prevent.stop="evh_4139696446929656_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Invalidate'|pgettext('BtnLockText')"
        :tooltip="'Invalidate'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_invalidate"
        @click.prevent.stop="evh_4700643919467772_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Revoke invalidated'|pgettext('BtnLockText')"
        :tooltip="'Revoke invalidated'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_revoke_invalidation"
        @click.prevent.stop="evh_295664594794476_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="item"
        :tooltip="'Delete'|pgettext('Resource|Command')"
        v-if="!item.isNew && !item.isReadOnly"
        @success="evh_8474446275270171_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </b-button-group>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingListItemHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newItem: this.$fn.pgettext("BillingListItem", "New item"),
          editItem: this.$fn.pgettext("BillingListItem", "Edit item"),
        }
        ,
        ux: null,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("BillingListItem", "Billing list item")
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.item.isNew ? this.messages.newItem : this.messages.editItem
    }
    return null;
  }

  async act_1040167445267876_emit_6650_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_6650, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_1040167445267876_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3601807637515735_emit_6654_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3601807637515735_emit_6654, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_3601807637515735_reloadSlickgrid_6656_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3601807637515735_reloadSlickgrid_6656, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_3601807637515735_request_6652_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3601807637515735_request_6652, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: true,
      },
    }
  }

  async evh_3601807637515735_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4139696446929656_emit_6660_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4139696446929656_emit_6660, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4139696446929656_reloadSlickgrid_6662_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4139696446929656_reloadSlickgrid_6662, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_4139696446929656_request_6658_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4139696446929656_request_6658, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: false,
      },
    }
  }

  async evh_4139696446929656_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4139696446929656_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4700643919467772_emit_6666_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4700643919467772_emit_6666, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4700643919467772_reloadSlickgrid_6668_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4700643919467772_reloadSlickgrid_6668, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_4700643919467772_request_6664_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4700643919467772_request_6664, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        void: true,
      },
    }
  }

  async evh_4700643919467772_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4700643919467772_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_295664594794476_emit_6672_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_295664594794476_emit_6672, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_295664594794476_reloadSlickgrid_6674_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_295664594794476_reloadSlickgrid_6674, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_295664594794476_request_6670_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_295664594794476_request_6670, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        void: false,
      },
    }
  }

  async evh_295664594794476_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_295664594794476_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8474446275270171_emit_6676_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8474446275270171_emit_6676, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_8474446275270171_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8474446275270171_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_emit_6650: actions.EmitAction;
    evh_1040167445267876_clickPreventStop_6649: actions.EventHandlerImpl;
    evh_1040167445267876_clickPreventStop: actions.EventHandlerGroup;
    act_3601807637515735_emit_6654: actions.EmitAction;
    evh_3601807637515735_success_6653: actions.EventHandlerImpl;
    act_3601807637515735_reloadSlickgrid_6656: actions.ReloadSlickgridAction;
    evh_3601807637515735_success_6655: actions.EventHandlerImpl;
    act_3601807637515735_request_6652: actions.RequestAction;
    evh_3601807637515735_clickPreventStop_6651: actions.EventHandlerImpl;
    evh_3601807637515735_clickPreventStop: actions.EventHandlerGroup;
    act_4139696446929656_emit_6660: actions.EmitAction;
    evh_4139696446929656_success_6659: actions.EventHandlerImpl;
    act_4139696446929656_reloadSlickgrid_6662: actions.ReloadSlickgridAction;
    evh_4139696446929656_success_6661: actions.EventHandlerImpl;
    act_4139696446929656_request_6658: actions.RequestAction;
    evh_4139696446929656_clickPreventStop_6657: actions.EventHandlerImpl;
    evh_4139696446929656_clickPreventStop: actions.EventHandlerGroup;
    act_4700643919467772_emit_6666: actions.EmitAction;
    evh_4700643919467772_success_6665: actions.EventHandlerImpl;
    act_4700643919467772_reloadSlickgrid_6668: actions.ReloadSlickgridAction;
    evh_4700643919467772_success_6667: actions.EventHandlerImpl;
    act_4700643919467772_request_6664: actions.RequestAction;
    evh_4700643919467772_clickPreventStop_6663: actions.EventHandlerImpl;
    evh_4700643919467772_clickPreventStop: actions.EventHandlerGroup;
    act_295664594794476_emit_6672: actions.EmitAction;
    evh_295664594794476_success_6671: actions.EventHandlerImpl;
    act_295664594794476_reloadSlickgrid_6674: actions.ReloadSlickgridAction;
    evh_295664594794476_success_6673: actions.EventHandlerImpl;
    act_295664594794476_request_6670: actions.RequestAction;
    evh_295664594794476_clickPreventStop_6669: actions.EventHandlerImpl;
    evh_295664594794476_clickPreventStop: actions.EventHandlerGroup;
    act_8474446275270171_emit_6676: actions.EmitAction;
    evh_8474446275270171_success_6675: actions.EventHandlerImpl;
    evh_8474446275270171_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_emit_6650 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_6650_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_1040167445267876_clickPreventStop_6649 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_6650,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_1040167445267876_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_clickPreventStop_6649],
      }
    );
    const act_3601807637515735_emit_6654 = new actions.EmitAction(
      {
        actionArgs: this.act_3601807637515735_emit_6654_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_success_6653 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_emit_6654,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3601807637515735_reloadSlickgrid_6656 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3601807637515735_reloadSlickgrid_6656_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_success_6655 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_reloadSlickgrid_6656,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_3601807637515735_request_6652 = new actions.RequestAction(
      {
        actionArgs: this.act_3601807637515735_request_6652_getActionArgs,
        displayName: "lock",
        events: [evh_3601807637515735_success_6653, evh_3601807637515735_success_6655],
      }
    );
    const evh_3601807637515735_clickPreventStop_6651 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_request_6652,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_3601807637515735_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3601807637515735_clickPreventStop_6651],
      }
    );
    const act_4139696446929656_emit_6660 = new actions.EmitAction(
      {
        actionArgs: this.act_4139696446929656_emit_6660_getActionArgs,
        events: [],
      }
    );
    const evh_4139696446929656_success_6659 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_emit_6660,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4139696446929656_reloadSlickgrid_6662 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4139696446929656_reloadSlickgrid_6662_getActionArgs,
        events: [],
      }
    );
    const evh_4139696446929656_success_6661 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_reloadSlickgrid_6662,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4139696446929656_request_6658 = new actions.RequestAction(
      {
        actionArgs: this.act_4139696446929656_request_6658_getActionArgs,
        displayName: "lock",
        events: [evh_4139696446929656_success_6659, evh_4139696446929656_success_6661],
      }
    );
    const evh_4139696446929656_clickPreventStop_6657 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_request_6658,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_4139696446929656_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4139696446929656_clickPreventStop_6657],
      }
    );
    const act_4700643919467772_emit_6666 = new actions.EmitAction(
      {
        actionArgs: this.act_4700643919467772_emit_6666_getActionArgs,
        events: [],
      }
    );
    const evh_4700643919467772_success_6665 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_emit_6666,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4700643919467772_reloadSlickgrid_6668 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4700643919467772_reloadSlickgrid_6668_getActionArgs,
        events: [],
      }
    );
    const evh_4700643919467772_success_6667 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_reloadSlickgrid_6668,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4700643919467772_request_6664 = new actions.RequestAction(
      {
        actionArgs: this.act_4700643919467772_request_6664_getActionArgs,
        displayName: "lock",
        events: [evh_4700643919467772_success_6665, evh_4700643919467772_success_6667],
      }
    );
    const evh_4700643919467772_clickPreventStop_6663 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_request_6664,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_4700643919467772_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4700643919467772_clickPreventStop_6663],
      }
    );
    const act_295664594794476_emit_6672 = new actions.EmitAction(
      {
        actionArgs: this.act_295664594794476_emit_6672_getActionArgs,
        events: [],
      }
    );
    const evh_295664594794476_success_6671 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_emit_6672,
        event: "success",
        displayName: "emit",
      }
    );
    const act_295664594794476_reloadSlickgrid_6674 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_295664594794476_reloadSlickgrid_6674_getActionArgs,
        events: [],
      }
    );
    const evh_295664594794476_success_6673 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_reloadSlickgrid_6674,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_295664594794476_request_6670 = new actions.RequestAction(
      {
        actionArgs: this.act_295664594794476_request_6670_getActionArgs,
        displayName: "lock",
        events: [evh_295664594794476_success_6671, evh_295664594794476_success_6673],
      }
    );
    const evh_295664594794476_clickPreventStop_6669 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_request_6670,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_295664594794476_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_295664594794476_clickPreventStop_6669],
      }
    );
    const act_8474446275270171_emit_6676 = new actions.EmitAction(
      {
        actionArgs: this.act_8474446275270171_emit_6676_getActionArgs,
        events: [],
      }
    );
    const evh_8474446275270171_success_6675 = new actions.EventHandlerImpl(
      {
        action: act_8474446275270171_emit_6676,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_8474446275270171_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_8474446275270171_success_6675],
      }
    );
    return {
      act_1040167445267876_emit_6650,
      evh_1040167445267876_clickPreventStop_6649,
      evh_1040167445267876_clickPreventStop,
      act_3601807637515735_emit_6654,
      evh_3601807637515735_success_6653,
      act_3601807637515735_reloadSlickgrid_6656,
      evh_3601807637515735_success_6655,
      act_3601807637515735_request_6652,
      evh_3601807637515735_clickPreventStop_6651,
      evh_3601807637515735_clickPreventStop,
      act_4139696446929656_emit_6660,
      evh_4139696446929656_success_6659,
      act_4139696446929656_reloadSlickgrid_6662,
      evh_4139696446929656_success_6661,
      act_4139696446929656_request_6658,
      evh_4139696446929656_clickPreventStop_6657,
      evh_4139696446929656_clickPreventStop,
      act_4700643919467772_emit_6666,
      evh_4700643919467772_success_6665,
      act_4700643919467772_reloadSlickgrid_6668,
      evh_4700643919467772_success_6667,
      act_4700643919467772_request_6664,
      evh_4700643919467772_clickPreventStop_6663,
      evh_4700643919467772_clickPreventStop,
      act_295664594794476_emit_6672,
      evh_295664594794476_success_6671,
      act_295664594794476_reloadSlickgrid_6674,
      evh_295664594794476_success_6673,
      act_295664594794476_request_6670,
      evh_295664594794476_clickPreventStop_6669,
      evh_295664594794476_clickPreventStop,
      act_8474446275270171_emit_6676,
      evh_8474446275270171_success_6675,
      evh_8474446275270171_success,
      reload: act_1040167445267876_emit_6650,
      lock: act_295664594794476_request_6670,
    }
  }
}

Vue.component("UcBillingListItemHeader", UcBillingListItemHeader);

</script>